<div class="tabs-header">
    <div class="left">
        <button
            data-uiid="asset-tab-overview"
            (click)="select('overview')"
            [class.active]="selectedTab === 'overview'"
        >
            {{ "tabs.overview" | t }}
        </button>
        <button
            data-uiid="asset-tab-assessments"
            (click)="select('assessments')"
            [class.active]="selectedTab === 'assessments'"
        >
            {{ "tabs.assessments" | t }}
        </button>
    </div>
    <div class="right">
        <button
            data-uiid="asset-tab-linked-items"
            (click)="select('linkedItems')"
            [class.active]="selectedTab === 'linkedItems'"
        >
            <mat-icon svgIcon="linked-items" />
        </button>
        <button
            data-uiid="asset-tab-documents-hyperlinks"
            (click)="select('documentandhyperlinks')"
            [class.active]="selectedTab === 'documentandhyperlinks'"
        >
            <mat-icon svgIcon="attachments" />
        </button>
        <button
            data-uiid="asset-tab-history"
            (click)="select('history')"
            [class.active]="selectedTab === 'history'"
        >
            <mat-icon svgIcon="history" />
        </button>
    </div>
</div>
